import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { StudiesService } from 'src/app/services/studies.service';

@Component({
  selector: 'app-download-modal-mobile',
  templateUrl: './download-modal-mobile.component.html',
  styleUrls: ['./download-modal-mobile.component.css']
})
export class DownloadModalMobileComponent implements OnInit {

  opened: boolean = false;

  @Output('ondDownloadStudy') downloadStudyEmitter = new EventEmitter<void>();

  constructor(
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
  }

  openModal(){
    this.opened = true;
  }

  closeModal(){
    this.opened = false;
  }


  downloadDicom(){

    this.downloadStudyEmitter.emit();
    
    this.closeModal();
  }

}
